import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { SpotQuoteRepository } from '../infra/SpotQuoteRepository'

export type GetSpotQuoteListFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
}

type GetSpotQuoteListParams = {
  limit: number
}

export function getSpotQuoteListFactory({
  spotQuoteRepository,
}: GetSpotQuoteListFactoryDependencies) {
  return function getSpotQuoteListImpl(
    params: GetSpotQuoteListParams,
    config?: { signal?: AbortSignal }
  ) {
    return spotQuoteRepository.getSpotQuoteList(params, config)
  }
}

export function getSpotQuoteList(
  params: GetSpotQuoteListParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = new HttpClient(API_URL)
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const get = getSpotQuoteListFactory({ spotQuoteRepository })

  return get(params, config)
}
